export default "/template/resource//static/media/errorSystem_light.387ef6c5.png";